/**
 * Responsible for defining API urls.
 */
export const API_CONFIG = {

  baseUrl: 'https://wniemiec-api-nshopping.onrender.com',
  bucketBaseUrl: 'https://nshop.s3.sa-east-1.amazonaws.com'
}
